// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetRegionExtensionItemRequest,
  TGetRegionExtensionItemModel,
  IMappers,
  TGetRegionExtensionItemResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetRegionExtensionResponse } from '../../entities/region_extension/GetRegionExtensionResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetRegionExtensionItemModel(
  parameters: IGetRegionExtensionItemRequest,
): TGetRegionExtensionItemModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'countryside-region-extension',
    pathApi: '/v1/get-region-extension-item/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetRegionExtensionItemOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetRegionExtensionItemRequest;
}

export async function fetchGetRegionExtensionItem<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetRegionExtensionItemOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetRegionExtensionItemResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetRegionExtensionItemModel(parameters),
    config,
  )) as FetchResponse<TGetRegionExtensionItemResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRegionExtensionResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetRegionExtensionItemResponse>;
}
